import React, { useState, useEffect, useMemo } from 'react';
import { Flex, Modal } from 'antd-mobile';

import styles from './index.modules.less';
import cx from 'classnames';
import Stores from 'config/Stores';

import request from 'utils/request';
import config from 'config/Config';

const MustBuyModal = ({ onCancle, onConfirm }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    initData();
  }, []);

  const initData = async () => {
    const result = await request({
      url: `user/info/getAccumulateMustBuyInfo`,
      host: config.HOST_MALL
    });
    if (result.data) {
      setData(result.data);
    }
  };

  const productInfo = useMemo(() => {
    const productList = data.mustBuyItemInfos || [];
    return productList.reduce((pre, cur) => {
      return pre + (cur.itemCode || '') + (cur.itemName || '');
    }, '');
  }, [data]);

  const firstProductId = useMemo(() => {
    return (
      (data.mustBuyItemInfos && data.mustBuyItemInfos[0] && data.mustBuyItemInfos[0].itemId) || ''
    );
  }, [data]);

  const renderBottomBtn = () => {
    return (
      <Flex direction="row" align="center" justify="between">
        <div
          className={cx(styles.btnContainer, styles.leftBtn)}
          onClick={() => {
            onCancle();
            Stores.AccoumulateMod.submitTapUpdate(0);
          }}>
          暂不升级
        </div>
        <div
          className={styles.btnContainer}
          onClick={() => {
            onConfirm(firstProductId);
            Stores.AccoumulateMod.submitTapUpdate(0);
            // onCancle();
          }}>
          去下单
        </div>
      </Flex>
    );
  };

  return (
    <Modal wrapClassName={styles.mustBuyModal} visible={true} transparent={true}>
      <div className={styles.mustBuyContainer}>
        <img
          src={'https://image.yofogo.com/image/app/success_tip.png'}
          className={styles.successTipIcon}
        />
        <p className={styles.successTipTitle}>
          已达<span>{data.cardTypeName || ''}</span>升级门槛，购买升级必选产品后即可完成晋级
        </p>
        <p className={styles.productInfo}>{`升级必选产品：${productInfo}`}</p>
        {renderBottomBtn()}
      </div>
    </Modal>
  );
};

export default MustBuyModal;



// WEBPACK FOOTER //
// ./src/pages/Shop/components/MustBuyModal/index.js